import React, { Component } from 'react'
import '../landing.css'

export default class Default extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <img className="mx-auto d-block banner" alt="404" src={`${process.env.PUBLIC_URL}/img/404.svg`} />
                            <h3 className="text-center" >
                                The requested URL{"  "}
                                <span className="text-danger
                                ">"{this.props.location.pathname}"</span> was
                                not found
                            </h3>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
